export function strapiImageUnoptimized(src: string) {
  const s = src?.trim();
  if (!s) {
    return false;
  }
  if (/localhost:1337|127\.0\.0\.1:1337/i.test(s)) {
    return true;
  }
  const strapiBase = process.env.NEXT_PUBLIC_STRAPI_URL?.trim();
  if (!strapiBase) {
    return false;
  }
  try {
    const baseHost = new URL(strapiBase).hostname;
    return new URL(s).hostname === baseHost;
  } catch {
    return false;
  }
}

/** Non-empty absolute http(s), protocol-relative, or path — safe for next/image `src`. */
export function isUsableImageSrc(src: string | undefined | null): src is string {
  const s = src?.trim();
  if (!s) {
    return false;
  }
  if (s.startsWith("/")) {
    return true;
  }
  // Protocol-relative URLs (e.g. //cdn.example.com/file)
  if (s.startsWith("//")) {
    try {
      const u = new URL(`https:${s}`);
      return u.protocol === "https:";
    } catch {
      return false;
    }
  }
  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s);
      return u.protocol === "http:" || u.protocol === "https:";
    } catch {
      return false;
    }
  }
  // Strapi sometimes returns "uploads/..." without a leading slash
  if (/^[\w.-]+\//.test(s) || s.startsWith("uploads/")) {
    return true;
  }
  return false;
}
